import Icon from '@mui/icons-material/Add';
import { SvgIconPropsOverrides } from '../../../model/icon';

export default function AddIcon({ className = '', ...props }: SvgIconPropsOverrides) {
	return <Icon className={`${className}`} {...props} />;
}
